var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Swiper_handlers;
import 'hammerjs';
import VideoManager from "./VideoManager";
import Video from "./Video";
import { isWebpSupported } from "../../utils";
import EventBus from "../../events/EventBus";
const IPHONE_FIX_DELAY_MS = 1500;
const FIRST_SLIDE_CLASS_NAME = 'first';
export default class SwiperController {
    constructor(selector, pixelRatio) {
        this.selector = selector;
        this.pixelRatio = pixelRatio;
        this.instances = [];
        this.pixelRatio = (pixelRatio > 1.5 ? 2 : 1);
        this.videoManager = new VideoManager();
    }
    update() {
        document.querySelectorAll(this.selector).forEach((element) => {
            if (element.dataset.swiperInitialized) {
                return;
            }
            if (element.querySelectorAll('.prod-teaser__dot').length < 2) {
                return;
            }
            const swiper = new Swiper(element, this.pixelRatio, this.videoManager);
            this.instances.push(swiper);
            const image = swiper.img;
            image.addEventListener('click', () => {
                setTimeout(() => {
                    if (!image.naturalWidth) {
                        image.src = image.src.replace(/#.*/, '') + '#' + new Date().getTime();
                    }
                }, IPHONE_FIX_DELAY_MS);
            });
        });
    }
    destroy() {
        for (const instance of this.instances) {
            instance.destroy();
        }
        this.instances = [];
    }
}
class Swiper {
    constructor(element, pixelRatio, manager) {
        this.element = element;
        this.manager = manager;
        this.srcList = [];
        _Swiper_handlers.set(this, {
            mouseLeave: null,
            mouseMove: null,
            imageLoad: null,
            click: null,
            setStripWidth: null,
        });
        this.loaded = [];
        this.loading = [];
        if (element.dataset.swiperInitialized) {
            // already initialized.
            return;
        }
        this.dots = Array.from(element.querySelectorAll('.prod-teaser__dot'));
        if (this.dots.length < 2) {
            return;
        }
        this.cover = element.querySelector('.prod-teaser__cover');
        this.img = this.cover.querySelector('img');
        this.setStripWidth();
        if (!this.img.complete) {
            const initSrcListOnload = () => {
                this.img.removeEventListener('load', initSrcListOnload);
                this.initSrcList(pixelRatio);
            };
            this.img.addEventListener('load', initSrcListOnload, { once: true });
        }
        else {
            this.initSrcList(pixelRatio);
        }
        this.initHammer(this.cover);
        this.addEventListeners();
        element.dataset.swiperInitialized = 'true';
    }
    setStripWidth() {
        this.stripWidth = (this.cover.clientWidth > this.cover.clientHeight ? this.cover.clientWidth : this.cover.clientHeight) / this.dots.length;
    }
    onImageLoad() {
        this.dots.map(item => item.classList.remove('prod-teaser__dot--active'));
        this.dots[this.activeIndex].classList.add('prod-teaser__dot--active');
        this.loaded[this.activeIndex] = true;
    }
    onSwipeLeft() {
        this.activate(this.activeIndex === this.srcList.length - 1 ? 0 : this.activeIndex + 1);
    }
    onSwipeRight() {
        this.activate(this.activeIndex === 0 ? this.srcList.length - 1 : this.activeIndex - 1);
    }
    onClick(e) {
        this.activate(this.dots.indexOf(e.target));
    }
    onMouseMove(e) {
        const left = Math.floor((this.video ? this.img : this.cover).getBoundingClientRect().left);
        const index = Math.floor((e.clientX - left) / this.stripWidth);
        this.activate(index < this.srcList.length ? index : index - 1);
    }
    onMouseLeave() {
        this.activate(0);
        if (this.video && this.video.locked) {
            this.video.unlock();
        }
    }
    activate(index) {
        let lockVideo = false;
        if (this.video && this.activeIndex !== undefined && !this.video.locked) {
            lockVideo = true;
        }
        if (index === this.activeIndex) {
            return;
        }
        if (this.srcList[index] === undefined) {
            return;
        }
        this.activeIndex = index;
        this.preloadImage(() => {
            if (!this.loaded[this.activeIndex]) {
                return;
            }
            if (lockVideo) {
                setTimeout(() => this.video.lock());
            }
            this.img.srcset = '';
            this.img.src = this.srcList[this.activeIndex];
            this.img.removeAttribute('width');
            this.img.removeAttribute('height');
            if (this.activeIndex === 0) {
                this.cover.classList.add(FIRST_SLIDE_CLASS_NAME);
            }
            else if (this.cover.classList.contains(FIRST_SLIDE_CLASS_NAME)) {
                this.cover.classList.remove(FIRST_SLIDE_CLASS_NAME);
            }
        });
    }
    destroy() {
        this.element.dataset.swiperInitialized = '';
        this.hammer.destroy();
        this.removeEventListeners();
        if (this.video) {
            this.manager.remove(this.video);
            this.video.destroy();
        }
    }
    preloadImage(callback) {
        if (this.loading[this.activeIndex] || this.loaded[this.activeIndex]) {
            callback();
            return;
        }
        this.loading[this.activeIndex] = false;
        const image = document.createElement('img');
        image.onload = () => {
            this.loaded[this.activeIndex] = true;
            this.loading[this.activeIndex] = false;
            callback();
        };
        image.onerror = () => {
            this.loading[this.activeIndex] = false;
        };
        image.src = this.srcList[this.activeIndex];
    }
    initSrcList(pixelRatio) {
        this.srcList.length = 0;
        const extension = isWebpSupported() ? 'webp' : 'jpg';
        for (const dot of this.dots) {
            this.srcList.push(dot.dataset[extension + (pixelRatio < 2 ? 'X1' : 'X2')]);
            if (dot.dataset.video) {
                this.video = new Video(dot.dataset.video, this.cover, this.srcList[0]);
                this.manager.add(this.video);
            }
        }
        if (this.img.currentSrc) {
            this.activeIndex = 0;
            this.img.src = this.img.currentSrc;
        }
        else {
            this.activate(0);
        }
        this.img.removeAttribute('srcset');
        this.cover.querySelectorAll('source').forEach(item => item.parentNode.removeChild(item));
    }
    initHammer(element) {
        this.hammer = new Hammer(element);
        this.hammer.get('swipe').set({ threshold: 30 });
        this.hammer.on('swipeleft', this.onSwipeLeft.bind(this));
        this.hammer.on('swiperight', this.onSwipeRight.bind(this));
    }
    addEventListeners() {
        this.cover.addEventListener('mouseleave', __classPrivateFieldGet(this, _Swiper_handlers, "f").mouseLeave = this.onMouseLeave.bind(this));
        this.cover.addEventListener('mousemove', __classPrivateFieldGet(this, _Swiper_handlers, "f").mouseMove = this.onMouseMove.bind(this));
        this.img.addEventListener('load', __classPrivateFieldGet(this, _Swiper_handlers, "f").imageLoad = this.onImageLoad.bind(this));
        this.dots.forEach(item => item.addEventListener('click', __classPrivateFieldGet(this, _Swiper_handlers, "f").click = this.onClick.bind(this)));
        EventBus.on('products:view-mode-change', __classPrivateFieldGet(this, _Swiper_handlers, "f").setStripWidth = this.setStripWidth.bind(this));
    }
    removeEventListeners() {
        this.cover.removeEventListener('mouseleave', __classPrivateFieldGet(this, _Swiper_handlers, "f").mouseLeave);
        this.cover.removeEventListener('mousemove', __classPrivateFieldGet(this, _Swiper_handlers, "f").mouseMove);
        this.img.removeEventListener('load', __classPrivateFieldGet(this, _Swiper_handlers, "f").imageLoad);
        this.dots.forEach(item => item.removeEventListener('click', __classPrivateFieldGet(this, _Swiper_handlers, "f").click));
        EventBus.off('products:view-mode-change', __classPrivateFieldGet(this, _Swiper_handlers, "f").setStripWidth);
    }
}
_Swiper_handlers = new WeakMap();
